import { SLoader } from '@avalara/skylab-sdk/react';

import { LoadingContainer, LoadingDisabler } from './styled/components/loading';

const Loading = () => (
  <>
    <LoadingDisabler />
    <LoadingContainer className='loading-spinner-container' data-ref='buy.loading-container'>
      <SLoader loading className='large' />
    </LoadingContainer>
  </>
);

export default Loading;
